// src/Pages/TaxMaster.jsx
import { gradients } from '../utils/theme';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, TextField, Button, Grid, Divider } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { Snackbar, Alert } from '@mui/material';
import { getCurrentFYear } from '../utils/financialYear';


export default function TaxMaster({ id, mode, onPopupCancel, connectionString, companyId: propsCompanyId }) {
    const { user, selectedCompany, loading } = useAuth();
    console.log(connectionString);
    // const { id } = useParams();
    const { id: routeId } = useParams();
    const recordId =
        mode === 'edit'
            ? id
            : routeId;

    const navigate = useNavigate();
    // company info
    // Safely extract values with fallbacks
    const userId = user?.UserId || null; // loggedInUser is null/undefined 
    const companyId =
        (mode === 'comp' || mode === 'edit')
            ? propsCompanyId
            : selectedCompany?.CompId;

     
     const AppRegID = selectedCompany?.AppRegID || null;       


    const fYear = getCurrentFYear();
    const branchId = selectedCompany?.BranchId; // same

    // form fields
    const [taxCode, setTaxCode] = useState('');
    const [gst, setGst] = useState('');
    const [cgst, setCgst] = useState('');
    const [sgst, setSgst] = useState('');
    const [igst, setIgst] = useState('');
    const [utgst, setUtgst] = useState('');
    const [gstCess, setGstCess] = useState('');

    // validation errors
    const [gstError, setGstError] = useState('');
    const [utgstError, setUtgstError] = useState('');
    const [gstCessError, setGstCessError] = useState('');
    const [formError, setFormError] = useState('');
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success', // success | error | warning | info
    });

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    // load existing on edit
    useEffect(() => {
        if (mode === 'edit' && recordId) {
            axios.get(`${connectionString}/api/tax/getDetails/${recordId}`)
                .then(({ data }) => {
                    setTaxCode(data.Taxcode);
                    setGst(String(data.GST));
                    setCgst(String(data.CGST));
                    setSgst(String(data.SGST));
                    setIgst(String(data.IGST));
                    setUtgst(String(data.UTGST));
                    setGstCess(String(data.GSTCess));
                })
                .catch(console.error);
        }
    }, [mode, recordId]);

    // validators
    const validatePct = (val, setErr, label) => {
        if (val === '') {
            setErr('');
        } else if (isNaN(val) || val < 0 || val > 100) {
            setErr(`Please enter ${label} between 0% to 100%`);
        } else {
            setErr('');
        }
    };

    // onBlur handlers
    const handleGstBlur = () => {
        validatePct(gst, setGstError, 'GST');
        if (!gstError && gst !== '') {
            const v = parseFloat(gst);
            const half = v / 2;
            setCgst(String(half));
            setSgst(String(half));
            setIgst(String(v));
        } else {
            setCgst('');
            setSgst('');
            setIgst('');
        }
    };
    const handleUtgstBlur = () => validatePct(utgst, setUtgstError, 'UTGST');
    const handleGstCessBlur = () => validatePct(gstCess, setGstCessError, 'GST CESS');


    const showSnackbar = (message, severity = 'success') => {
        setSnackbar({
            open: true,
            message,
            severity,
        });
    };

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };


    const handleSubmit = async e => {
        e.preventDefault();
        // final check
        if (gstError || utgstError || gstCessError) {
            setFormError('* OOPS! Fill data properly.');
            return;
        }
        setFormError('');
        try {
            const payload = {
                Taxcode: taxCode,
                GST: parseFloat(gst) || 0,
                CGST: parseFloat(cgst) || 0,
                SGST: parseFloat(sgst) || 0,
                IGST: parseFloat(igst) || 0,
                UTGST: parseFloat(utgst) || 0,
                GSTCess: parseFloat(gstCess) || 0,
                companyId,
                AppRegID,
                fYear,
                branchId,
                userId,
            };
            console.log('Payload', payload)
            if (mode === 'add' || mode === 'comp') {
                await axios.post(`${connectionString}/api/tax/Insert`, payload);
                showSnackbar('Data inserted successfully', 'success');
            } else {
                await axios.put(`${connectionString}/api/tax/Update/${recordId}`, payload);
                showSnackbar('Data updated successfully', 'success');
            }

            // ✅ 600ms ke baad popup close / navigate
            setTimeout(() => {
                if (onPopupCancel) {
                    onPopupCancel();
                } else {
                    navigate('/main/taxDetail');
                }
            }, 600);
        } catch (err) {
            console.error(err);
            showSnackbar(
                `Error ${mode === 'add' || mode === 'comp' ? 'inserting' : 'updating'} data`,
                'error'
            );
        }
    };

    const handleCancel = () => {
        if (onPopupCancel) onPopupCancel();
        else navigate('/main/taxDetail');
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                handleSubmit(e);
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleCancel();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    return (
        <>
            <Box sx={{ height: 4, background: gradients.primaryRow }} />
            <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                    {mode === "add" || mode === "comp" ? "Add New Tax" : "Edit Tax"}
                </Typography>
            </Box>
            <Divider />
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Box sx={{ px: 2.5, pt: 2, pb: 0.5}}>
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12}>
                            <TextField fullWidth required label="Tax Code" size='small' value={taxCode} InputLabelProps={{ sx: requiredAsteriskStyle }} onChange={e => setTaxCode(e.target.value)} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth required label="GST (%)" type="number" size='small' InputLabelProps={{ sx: requiredAsteriskStyle }} value={gst} onChange={e => setGst(e.target.value)} onBlur={handleGstBlur} error={!!gstError} helperText={gstError} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label="CGST (%)" type="number" value={cgst} size='small' InputProps={{ readOnly: true }} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label="SGST (%)" size='small' type="number" value={sgst} InputProps={{ readOnly: true }} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label="IGST (%)" size='small' type="number" value={igst} InputProps={{ readOnly: true }} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label="UTGST (%)" size='small' type="number" value={utgst} onChange={e => setUtgst(e.target.value)} onBlur={handleUtgstBlur} error={!!utgstError} helperText={utgstError} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label="GST Cess (%)" size='small' type="number" value={gstCess} onChange={e => setGstCess(e.target.value)} onBlur={handleGstCessBlur} error={!!gstCessError} helperText={gstCessError} sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
                        </Grid>
                    </Grid>
                    {formError && (
                        <Typography color="error" align="center" sx={{ mt: 1 }}>
                            {formError}
                        </Typography>
                    )}
                </Box>
                <Divider sx={{ mt: 1.5 }} />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={handleCancel} type="button" variant="outlined" color="inherit" size="small">
                        Cancel
                    </Button>
                    <Button variant="contained" type="submit" size="small">
                        {mode === 'add' || mode === "comp" ? 'Save' : 'Update'}
                    </Button>
                </Box>
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}